


































































import Vue from "vue";
import ImageShow from "../show/ImageShow.vue";
import { fileUploadURL } from "@/dex-shared/settings/endpoints";
import { mapGetters } from 'vuex';

export default Vue.extend({
  components: {
    ImageShow
  },

  computed: {
    ...mapGetters({
      imageById: "imageById"
    }),
    image() {
      return this.imageById(this.imageId)
    }
  },

  props: {
    imageId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      selectedFile: null,
      uploadedImage: null,
      uploadingImage: false,
      pasteImageText: ""
    };
  },

  methods: {
    updatePropertyValue: function(propToUpdate:string, value:any) {
      this.$store.commit(
        "UPDATE_ENTITY_PROP",
        {
          id: this.image.id,
          entity: "images",
          propToUpdate,
          value
        }
      )
    },

    updateOrigin(value: string) {
      this.updatePropertyValue(
        "source",
        {
          ...this.image.source,
          origin: value
        }
      );
    },

    onFileChanged(event: any) {
      this.selectedFile = event.target.files[0];
      this.onUpload();
    },

    pasteImage(e) {
      const { files } = e.clipboardData || e.originalEvent.clipboardData;

      this.selectedFile = files[0];
      this.onUpload();
    },

    async onUpload() {
      this.uploadingImage = true;
      var reader = new FileReader();

      reader.onloadend = async () => {
        let response = await fetch(`${fileUploadURL}`, {
          method: "POST",
          mode: "cors",
          body: JSON.stringify({ image: reader.result })
        });
        this.uploadingImage = false;
        let secondResponse = await response.json();
        this.uploadedImage = secondResponse.location;
        this.imageUrl = secondResponse.location;
        this.updatePropertyValue("url", this.imageUrl);
      };

      await reader.readAsDataURL(this.selectedFile);
      this.updatePropertyValue("url", this.imageUrl);
    }
  }
});
